const ALL = "All";
const ADVERTISER_FILTER = {
  triggerValue: ALL,
  value: ALL.toLowerCase(),
  type: "dropdown",
  filterDataKey: "",
};

const STATUS_FILTER = {
  triggerValue: ALL,
  value: ALL.toLowerCase(),
  type: "dropdown",
  filterDataKey: "",
};

const ACTIVE_FILTER = {
  triggerValue: ALL,
  value: ALL.toLowerCase(),
  type: "dropdown",
  filterDataKey: "",
};

const CreativesConstants = {
  ACTIVE_STATUS: "active",
  ALL,
  AD_SERVER_MEDIAMATH: "MediaMath",
  CHANGE_LOG_FIELDS: {
    AD_FORMAT: "ad_format",
    ADD: "add",
    CLICKTHROUGH_URL: "clickthrough_url",
    CLOCK_NUMBER: "clock_number",
    CUSTOM_VAST: "custom_vast",
    CUSTOM_VAST_URL: "custom_vast_url",
    DELETE: "delete",
    END_DATE: "end_date",
    GROUP_ID: "concept_id",
    LANDING_PAGE_URL: "landing_page",
    NAME: "name",
    START_DATE: "start_date",
    STATUS: "status",
    THREE_PAS_ID: "external_identifier",
    TRACKING_PIXELS: "tracking_pixels",
    UPDATE: "update",
  },
  CHANGELOG_DATEFORMAT: "LL-dd-yyyy",
  CHANNEL_TYPE: {
    DISPLAY: "Display",
    VIDEO: "Video",
    AUDIO: "Audio",
    NATIVE: "Native",
  },
  DEFAULT_DATE_FORMAT: "yyyy-LL-dd",
  DEFAULT_FILTERS: {
    advertiserId: {
      ...ADVERTISER_FILTER,
    },
    status: {
      ...STATUS_FILTER,
    },
    active: {
      ...ACTIVE_FILTER,
    },
  },
  DISPLAY_AD_FORMAT: {
    DISPLAY: "Display",
    MOBILE: "Mobile",
    EXPANDABLE: "Expandable",
  },
  DISPLAY_AD_TAG_TYPE: {
    JAVASCRIPT: "Javascript",
    IFRAME: "Iframe",
    IMAGE: "Image",
  },
  DISPLAY_DIMENSIONS: {
    CUSTOM: "custom_dimension",
    DEFAULT: "default_dimension",
  },
  EXPANSION_DIRECTION: {
    L: "Left",
    R: "Right",
    U: "Up",
    D: "Down",
    LU: "UpLeft",
    RU: "UpRight",
    LD: "DownLeft",
    RD: "DownRight",
  },
  EXPANSION_TRIGGER: {
    AUTOMATIC: "Automatic",
    MOUSEOVER: "Mouseover",
    CLICK: "Click",
  },
  FOURGIGABYTESINBYTES: 4294967296,
  GRID_MIN_HEIGHT: "175px",
  HOUR_MINUTE_SECOND_DATEFORMAT: "HH:mm:ss",
  INACTIVE_STATUS: "inactive",
  LIMIT_ROWS_SELECTED: 100,
  MAXDISPLAYKILOBYTESINBYTES: 500000,
  MAXGIGABYTESINBYTES: 1073741824,
  MAXMEGABYTESINBYTES: 110000,
  PAGE_SIZE: 100,
  SIDE_PANEL_CONTENT_WITH: 800,
  SIDE_PANEL_MIN_WIDTH: 100,
  TIME_WINDOW_CUSTOM: "custom",
  TIME_WINDOW_LAST7: "last_7_days",
  TIME_WINDOW_LAST30: "last_30_days",
  VAST_TYPE_URL: "URL",
  VAST_TYPE_XML: "XML",
};

export default CreativesConstants;
